import React, { useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

const SuccessionDealStructure = ({ query, updateCfaQuery, currentUser, intl }) => {
  const features = currentUser?.company?.features || [];
  const cashFlowOrdinaryIncomeTaxRates = features.includes('cash_flow_ordinary_income_tax_rates');

  const validate = () => {
    let valid = true;

    if (!query.cashFlowLength || parseFloat(query.cashFlowLength) < 1) {
      valid = false;
    }

    if (cashFlowOrdinaryIncomeTaxRates && (!query.cashFlowProductionShift || parseFloat(query.cashFlowProductionShift) < 1)) {
      valid = false;
    }

    if (!query.name) {
      valid = false;
    }

    if (query.valid !== valid) {
      updateCfaQuery({ ...query, valid });
    }
  };

  // Set default production shift if feature flag is not enabled
  useEffect(() => {
    if (!cashFlowOrdinaryIncomeTaxRates) {
      updateCfaQuery({ ...query, cashFlowProductionShift: 3 });
    }
  }, [cashFlowOrdinaryIncomeTaxRates]);

  // Run validation when relevant fields change
  useEffect(() => {
    validate();
  }, [query.cashFlowLength, query.cashFlowProductionShift, query.name]);

  return (
    <div className="max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">
        <FormattedMessage id="calculators.cfa.terms_of_deal_q"/>
      </h2>
      
      <p className="text-gray-600 mb-8">
        <FormattedMessage id="calculators.cfa.deal_structure_copy"/>
      </p>

      <div className="space-y-6">
        {/* Deal Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <FormattedMessage id="calculators.cfa.please_deal_name"/>
          </label>
          <input
            type="text"
            value={query.name || ''}
            onChange={(e) => updateCfaQuery({ ...query, name: e.target.value })}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
            placeholder={intl.formatMessage({ id: 'succession.cash_flow_analysis.deal_structure.placeholder_deal_name' })}
          />
        </div>

        {/* Cash Flow Length */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <FormattedMessage id="calculators.cfa.cash_flow_length_q"/>
          </label>
          <input
            type="number"
            value={query.cashFlowLength || ''}
            onChange={(e) => {
              let val = parseInt(e.target.value);
              if (val > 20) {
                val = 20;
              }
              updateCfaQuery({ ...query, cashFlowLength: val });
            }}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
            placeholder="6"
            min="1"
            max="20"
          />
          <p className="mt-1 text-sm text-gray-500">
            {intl.formatMessage({ id: 'succession.cash_flow_analysis.deal_structure.maximum_years' })}
          </p>
        </div>

        {/* Production Shift (only if feature flag enabled) */}
        {cashFlowOrdinaryIncomeTaxRates && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <FormattedMessage id="calculators.cfa.cash_flow_prod_shift"/>
            </label>
            <input
              type="number"
              value={query.cashFlowProductionShift || ''}
              onChange={(e) => updateCfaQuery({ ...query, cashFlowProductionShift: parseInt(e.target.value) })}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
              placeholder="3"
              min="1"
            />
          </div>
        )}
      </div>

      {/* Validation Status */}
      {!query.valid && (
        <div className="mt-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
          <p className="text-yellow-800 text-sm">
            {intl.formatMessage({ id: 'succession.cash_flow_analysis.deal_structure.complete_required_fields' })}
          </p>
        </div>
      )}
    </div>
  );
};

export default injectIntl(SuccessionDealStructure); 